// Vendors
import { TrackingEventsEnum, TrackingLinkEventReturnType } from '@openbank/ziniaweb-ui-core-models';
// Types
import { TrackBuilderType } from 'types/track-builder.type';
import { LayoutFooterTrackingHandlersType } from './types/layout-footer.tracking.handlers.type';

const cancelApplicationLinkClickTrackingHandler = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'cancel',
    format: 'link',
    component: 'navigationFooter',
    element: 'cancelApplication',
    eventAction: 'clickLink',
    eventCategory: 'layoutFooterCancel',
    eventLabel: 'cancelApplicationLink',
  },
  type: TrackingEventsEnum.LINK,
});

const closeCancelApplicationModalClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'close',
    format: 'cross',
    component: 'modalContainer/cancelLoanApplication',
    element: 'cross',
    eventAction: 'modalCancelLoanApplication',
    eventCategory: 'layoutCancelModal',
    eventLabel: 'close',
  },
  type: TrackingEventsEnum.LINK,
});

const LayoutFooterTrackingHandlers = (
  track: TrackBuilderType
): LayoutFooterTrackingHandlersType => ({
  handleCancelApplicationLinkClickTracking: () =>
    track(cancelApplicationLinkClickTrackingHandler()),
  handleCloseCancelApplicationModalClickTracking: () =>
    track(closeCancelApplicationModalClickTracking()),
});

export { LayoutFooterTrackingHandlers };
